import classNames from "classnames";

export default function GoogleCalendarLogo(props: { isDim?: boolean }) {
	return (
		<div
			className={classNames("flex items-center gap-1", {
				"grey-text": props.isDim,
			})}
		>
			<i className="fab fa-google"></i>
			<p>Cal</p>
		</div>
	);
}
